import { getCommon } from '@/components/report/service';
import { CALCWEIGHT, Aggregator } from '@/models/GenerateCondit/Interrelated';
import moment from 'moment';
import { history } from 'umi';
import { crudRequest } from '@/services/api';
import { InitOrganizationAuth } from '@/services/area';
import { message } from 'antd';
import { getToDay } from '@/utils/date';

const weekArray = ['第一周', '第二周', '第三周', '第四周'];
const dayArray = ['0', '-1', '-2', '-3', '-4', '-5', '-6'];

let [startDate] = getToDay();

export default {
  namespace: 'ActualProductionRatioDetail2',
  state: {
    onSearch: false,
    access: InitOrganizationAuth(),
    searchParams: {
      lineTime2: startDate
        .subtract(2, 'days')
        .format('YYYY-MM-DD HH:mm:ss'),
      isStandard: '',
      transportLineType: '',
      // goodsType: '',
      volumesType: '',
      startDate: '',
      endDate: '',
      departureCenter: undefined,
      arrivalCenter: '',
      isWorkDay: ['工作日', '周六', '周日'],
      routeType: '营运区-营运区',
      areaProperty: '',
    },
    '/cost/planProductionRatioDetail': {
      access: InitOrganizationAuth(),
      dayTableDatas: [],
      weekTableDatas: [],

    },
    '/cost/actualProductionRatioDetail': {
      access: InitOrganizationAuth(),
      dayTableDatas: [],
      weekTableDatas: [],

    },
  },

  effects: {
    /**
     * 获取周累计值
     */
    *getWeekSumData({ payload }, { call, put, select }) {
      const {
        departureCenter, // 出发
        arrivalCenter, // 到达
        isWorkDay, // 周类型
        transportLineType, // 区域属性
        volumesType, // 运力类型
        isStandard, // 基准类型
        startDate, //
        endDate,
        routeType,
      } = payload;

      const PATHNAME = history?.location?.pathname;

      let ActualProductionRatioDetail2 = yield select(
        ({ ActualProductionRatioDetail2 }) => ActualProductionRatioDetail2,
      );

      const {
        // tableDatas,
        access,
      } = ActualProductionRatioDetail2;

      if (!access.isHead && departureCenter == null) {
        message.warn('请选择出发站点/营运区');
        return;
      }

      let goodsAndFilters = [];
      if (transportLineType) {
        goodsAndFilters.push({ key: 'goodsType', value: transportLineType });
      }

      // let andFilters = [];
      let dimensions = ['monthType'];
      let directionKey = handleDirectionFilter(
        routeType,
        departureCenter,
        goodsAndFilters,
        arrivalCenter,
      );
      dimensions.push(...directionKey);

      let inFilters = [
        {
          key: 'monthType',
          value: [...weekArray],
        },
      ];
      if (isWorkDay && isWorkDay.length) {
        inFilters.push({ key: 'isWorkDay', value: isWorkDay });
      }

      const result = yield call(getCommon, {
        dataSource: 't_roi_goods_result',
        dimensions,
        aggregators: [CALCWEIGHT],
        simpleGranularity: 'day',
        startDate: startDate,
        endDate: endDate,
        andFilters: goodsAndFilters,
        inFilters: inFilters,
      });
      if (!result) {
        // message.error('查询出现错误');
        return;
      }

      let volumeAndFilters = [];
      if (volumesType && volumesType === '正班') {
        inFilters.push({
          key: 'volumesType',
          value: ['正班双边', '正班单边'],
        });
      }
      if (volumesType && volumesType === '加班') {
        volumeAndFilters.push({ key: 'volumesType', value: '临时加班' });
      }
      volumeAndFilters.push({
        key: 'volumeName',
        value: PATHNAME === '/cost/planProductionRatioDetail' ? 1 : 0,
      });
      if (isStandard) {
        volumeAndFilters.push({
          key: 'isStandard',
          value: isStandard === '基准线路' ? isStandard : '',
        });
      }

      if (transportLineType) {
        volumeAndFilters.push({ key: 'transportLineType', value: transportLineType });
      }

      let dimensions1 = ['monthType'];
      let directionKey1 = handleDirectionFilter(
        routeType,
        departureCenter,
        volumeAndFilters,
        arrivalCenter,
      );
      dimensions1.push(...directionKey1);

      const volumeResult = yield call(getCommon, {
        dataSource: 't_roi_volume_result',
        dimensions: dimensions1,
        simpleGranularity: 'day',
        startDate: startDate,
        endDate: endDate,
        andFilters: volumeAndFilters,
        inFilters: inFilters,
        aggregators: [new Aggregator('doubleSum', 'volumes', 'volumes')],
      });
      if (!volumeResult) {
        // message.error('查询出现错误');
        return;
      }

      let weekTableDatas = handleData(
        weekArray,
        result,
        volumeResult,
        item => item.monthType,
        directionKey,
      );

      let dayTableDatas = yield select(
        ({ ActualProductionRatioDetail2 }) => ActualProductionRatioDetail2?.[PATHNAME].dayTableDatas,
        // directionKey,
      );
      // console.log('[PATHNAME]',PATHNAME)
      crudRequest(
        PATHNAME === '/cost/planProductionRatioDetail'
          ? '/api/route/planProductionRatioDetail/search_week'
          : '/api/route/actualProductionRatioDetail/search_week',
      );

      yield put({
        type: 'updateState',
        payload: {
          [PATHNAME]: { weekTableDatas, dayTableDatas },
        },
      });
    },

    /**
     * 获取单日值
     */
    *getDaySumData(_, { call, put, select }) {
      let ActualProductionRatioDetail2 = yield select(
        ({ ActualProductionRatioDetail2 }) => ActualProductionRatioDetail2,
      );

      const {
        // tableDatas,
        access,
        searchParams,
      } = ActualProductionRatioDetail2;

      const PATHNAME = history?.location?.pathname;
      const {
        // lineTime,
        departureCenter, // 出发
        arrivalCenter, // 到达
        transportLineType, // 区域属性
        volumesType, // 运力类型
        isStandard, // 基准类型
        // startDate,
        // endDate,
        routeType,
      } = searchParams;

      if (!access.isHead && departureCenter == null) {
        message.warn('请选择出发站点/营运区');
        return;
      }

      let startDate = moment(searchParams.lineTime2)
        .startOf('day')
        .subtract(6, 'days')
        .format('YYYY-MM-DD HH:mm:ss');
      let endDate = moment(searchParams.lineTime2)
        .endOf('day')
        .format('YYYY-MM-DD HH:mm:ss');

      let goodsAndFilters = [];
      if (transportLineType) {
        goodsAndFilters.push({ key: 'goodsType', value: transportLineType });
      }
      // let andFilters = [];
      let dimensions = ['__time'];
      let directionKey = handleDirectionFilter(
        routeType,
        departureCenter,
        goodsAndFilters,
        arrivalCenter,
      );
      dimensions.push(...directionKey);

      let inFilters = [];

      // 请求结算重量数据
      const result = yield call(getCommon, {
        dimensions,
        simpleGranularity: 'day',
        startDate: startDate,
        endDate: endDate,
        dataSource: 't_roi_goods_result',
        andFilters: goodsAndFilters,
        inFilters,
        aggregators: [CALCWEIGHT],
      });
      if (!result) {
        // message.error('查询出现错误');
        return;
      }

      let volumeAndFilters = [];
      if (volumesType && volumesType === '正班') {
        inFilters.push({
          key: 'volumesType',
          value: ['正班双边', '正班单边'],
        });
      }
      if (volumesType && volumesType === '加班') {
        volumeAndFilters.push({ key: 'volumesType', value: '临时加班' });
      }
      if (isStandard) {
        volumeAndFilters.push({
          key: 'isStandard',
          value: isStandard === '基准线路' ? isStandard : '',
        });
      }
      if (transportLineType) {
        volumeAndFilters.push({ key: 'transportLineType', value: transportLineType });
      }
      volumeAndFilters.push({
        key: 'volumeName',
        value: PATHNAME === '/cost/planProductionRatioDetail' ? 1 : 0,
      });

      let dimensions1 = ['__time'];
      let directionKey1 = handleDirectionFilter(
        routeType,
        departureCenter,
        volumeAndFilters,
        arrivalCenter,
      );
      dimensions1.push(...directionKey1);
      // 请求实际运力数据
      const volumeResult = yield call(getCommon, {
        dimensions: dimensions1,
        simpleGranularity: 'day',
        startDate: startDate,
        endDate: endDate,
        aggregators: [new Aggregator('doubleSum', 'volumes', 'volumes')],
        dataSource: 't_roi_volume_result',
        andFilters: volumeAndFilters,
        inFilters: inFilters,
      });
      if (!volumeResult) {
        // message.error('查询出现错误');
        return;
      }

      let dayTableDatas = handleData(
        dayArray,
        result,
        volumeResult,
        item => moment(item.druidDefaultSearchTime).diff(endDate, 'days'),
        directionKey,
      );

      let weekTableDatas = yield select(
        ({ ActualProductionRatioDetail2 }) => ActualProductionRatioDetail2?.[PATHNAME].weekTableDatas,
      );
      // tableDatas=dayTableDatas;

      // let newTableDatas = [];
      // let countData = {}
      // Object.entries(volumeData).forEach(([key, value]) => {
      //   let goodItem = goodsData[value.taskNo];
      // volumeData[
      //   `${value.taskNo}-${value.directionDepartureCenter}-${value.directionArrivalCenter}`
      // ];

      // if (!volumeItem) {
      //   return;
      // }

      //   let settlementLoadingRate = goodItem?.calcWeight / value?.actualCapacity / 1000; // 结算装载率
      //   let volumeLoadingRate = goodItem?.volume / value?.actualPosition; // 体积装载率
      //   let exceptionType =
      //     settlementLoadingRate > 0.8 ? (settlementLoadingRate > 0.9 ? '爆仓' : '') : '空仓'; //判断结算装载率 小于80%空仓   大于90% 爆仓
      //   let __time = moment(value.druidDefaultSearchTime).format('MM/DD');
      //   newTableDatas.push({
      //     ...value,
      //     ...(goodItem ?? {}),
      //     settlementLoadingRate,
      //     volumeLoadingRate,
      //     exceptionType,
      //     __time,
      //   });
      // });
      //
      // // 处理加载数据
      // let newResult;
      // if (offset === 0) {
      //   newResult = newTableDatas;
      // } else {
      //   newResult = [...tableDatas, ...newTableDatas];
      // }

      // crudRequest('/api/route/actualProductionRatioDetail/search_day')
      crudRequest(
        PATHNAME === '/cost/planProductionRatioDetail'
          ? '/api/route/planProductionRatioDetail/search_day'
          : '/api/route/actualProductionRatioDetail/search_day',
      );

      yield put({
        type: 'updateState',
        payload: {
          [PATHNAME]: { dayTableDatas, weekTableDatas },
        },
      });
    },
  },
  //todo

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    updateSearchParams(state, { payload }) {
      return { ...state, searchParams: { ...state.searchParams, ...payload } };
    },
  },
};

/**
 *
 * @param {*} routeType 流向类型
 * @param {*} departureCenter 出发组织
 * @param {*} goodsAndFilters andFilters
 * @param {*} arrivalCenter 到达组织
 * @returns
 */
function handleDirectionFilter(routeType, departureCenter, goodsAndFilters, arrivalCenter) {
  let directionKey = [];
  if (routeType === '营运区-营运区') {
    if (departureCenter) {
      goodsAndFilters.push({ key: 'departureProvinceAreaCode', value: departureCenter?.code });
    }
    if (arrivalCenter) {
      goodsAndFilters.push({ key: 'arrivalProvinceAreaCode', value: arrivalCenter?.code });
    }
    directionKey.push('departureProvinceArea', 'arrivalProvinceArea');
  } else if (routeType === '营运区-分拨') {
    if (departureCenter) {
      goodsAndFilters.push({ key: 'departureProvinceAreaCode', value: departureCenter?.code });
    }
    if (arrivalCenter) {
      goodsAndFilters.push({ key: 'arrivalCenterCode', value: arrivalCenter?.code });
    }
    directionKey.push('departureProvinceArea', 'arrivalCenter');
  } else if (routeType === '分拨-营运区') {
    if (departureCenter) {
      goodsAndFilters.push({ key: 'departureCenterCode', value: departureCenter?.code });
    }
    if (arrivalCenter) {
      goodsAndFilters.push({ key: 'arrivalProvinceAreaCode', value: arrivalCenter?.code });
    }
    directionKey.push('departureCenter', 'arrivalProvinceArea');
  } else if (routeType === '分拨-分拨') {
    if (departureCenter) {
      goodsAndFilters.push({ key: 'departureCenterCode', value: departureCenter?.code });
    }
    if (arrivalCenter) {
      goodsAndFilters.push({ key: 'arrivalCenterCode', value: arrivalCenter?.code });
    }
    directionKey.push('departureCenter', 'arrivalCenter');
  }

  return directionKey;
}

/**
 *
 * @param {Array} columeArray 字段数组
 * @param {Array} goodsResult 货物
 * @param {Array} volumeResult 运力
 * @param {Function} columnName 数据对应字段key
 * @returns
 */
function handleData(columeArray, goodsResult, volumeResult, columnName, directionKey) {
  // 字段数组
  let allCountInit = columeArray.reduce((pre, current) => {
    pre[current] = 0;
    return pre;
  }, {});

  const goodsData = JSON.parse(goodsResult.data || null)
    .map(item => item.event)
    // .map(item => {
    //   return {
    //     ...item,
    //     calcWeight: item.calcWeight ? Math.abs(item.calcWeight) : item.calcWeight,
    //   };
    // })
    .reduce(
      (pre, current) => {
        //出发-到达 (上海营运区区-天津营运区区)
        let direction = `${current[directionKey[0]]}-${current[directionKey[1]]}`;
        // 索引
        let name = columnName(current);

        if (pre[direction]) {
          pre[direction][name] = pre[direction][name] + current.calcWeight;
        } else {
          pre[direction] = { ...allCountInit, [name]: current.calcWeight };
        }

        pre['合计'] = {
          ...pre['合计'],
          [name]: pre['合计']?.[name] + current.calcWeight,
        };
        return pre;
      },
      { 合计: { ...allCountInit } },
    );

  const volumeData = JSON.parse(volumeResult.data || null)
    .map(item => item.event)
    .reduce(
      (pre, current) => {
        let name = columnName(current);
        let direction = `${current[directionKey[0]]}-${current[directionKey[1]]}`;
        if (pre[direction]) {
          pre[direction][name] = pre[direction][name] + current.volumes;
        } else {
          pre[direction] = { ...allCountInit, [name]: current.volumes };
        }
        pre['合计'] = {
          ...pre['合计'],
          [name]: pre['合计']?.[name] + current.volumes,
        };
        return pre;
      },
      { 合计: { ...allCountInit } },
    );
  // 计算合计
  let sumResult = columeArray.reduce((pre, current) => {
    if (goodsData['合计']?.[current] && volumeData['合计']?.[current]) {
      pre[`${current}Goods`] = goodsData['合计']?.[current];
      pre[`${current}Volume`] = volumeData['合计']?.[current];
      pre[current] = goodsData['合计']?.[current] / volumeData['合计']?.[current] / 1000;
    }
    return pre;
  }, {});

  // 计算合计月累计
  let monthSumResult = columeArray.reduce(
    (pre, current) => {
      if (goodsData['合计']?.[current] && volumeData['合计']?.[current]) {
        pre['calcWeight'] += goodsData['合计']?.[current];
        pre['volumes'] += volumeData['合计']?.[current];
      }
      return pre;
    },
    { calcWeight: 0, volumes: 0 },
  );

  let tableDatas = [
    {
      direction: '合计',
      ...sumResult,
      totalGoods: monthSumResult.calcWeight,
      totalVolume: monthSumResult.volumes,
      month: monthSumResult.calcWeight / monthSumResult.volumes / 1000,
    },
  ];
  // let countData = {}
  Object.entries(goodsData).forEach(([key, value]) => {
    if (key === '合计') {
      return;
    }
    let weekResult = columeArray.reduce((pre, current) => {
      pre[`${current}Goods`] = value?.[current];
      pre[`${current}Volume`] = volumeData[key]?.[current];
      if (!pre['totalGoods']) {
        pre['totalGoods'] = 0;
      }
      if (!pre['totalVolume']) {
        pre['totalVolume'] = 0;
      }
      pre['totalGoods'] += value?.[current];
      pre['totalVolume'] += volumeData[key]?.[current];
      pre[current] = value?.[current] / volumeData[key]?.[current] / 1000;
      return pre;
    }, {});

    weekResult['month'] = weekResult['totalGoods'] / weekResult['totalVolume'] / 1000;

    if (value && volumeData[key]) {
      tableDatas.push({
        direction: key,
        ...weekResult,
        month:
          Object.values(value).reduce((pre, cur) => pre + cur, 0) /
          Object.values(volumeData[key]).reduce((pre, cur) => pre + cur, 0) /
          1000,
      });
    }
  });
  return tableDatas;
}
